import HistoricoSituacaoVenda from './HistoricoSituacaoVenda';

export default HistoricoSituacaoVenda;
